import React, { memo, useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { CardView, Spacer, rem } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import InsightsPieChart from './InsightsPieChart';
import InsightsCategorySelector from './InsightsCategorySelector';
const InsightsHeader = ({ data, total, count, category, setCategory, sliceIndexMap, defaultSliceKey, selectedPieSlice, setSelectedPieSlice, }) => {
    const sectionHeaderText = useMemo(() => {
        switch (category) {
            case 'HOLDINGS':
                return 'Holdings breakdown';
            case 'SECTOR':
                return 'Sector breakdown';
            default:
                return '';
        }
    }, [category]);
    if (!data.length) {
        return null;
    }
    return (<>
      <CardView style={styles.card}>
        <InsightsPieChart data={data} total={total} count={count} category={category} sliceIndexMap={sliceIndexMap} defaultSliceKey={defaultSliceKey} selectedPieSlice={selectedPieSlice} setSelectedPieSlice={setSelectedPieSlice}/>
        <Spacer h={16}/>
        <InsightsCategorySelector category={category} setCategory={setCategory}/>
      </CardView>
      <Spacer h={8}/>
      <SectionHeader horizontalMargins>{sectionHeaderText}</SectionHeader>
      <Spacer h={16}/>
    </>);
};
const styles = StyleSheet.create({
    card: {
        padding: rem(24),
    },
});
export default memo(InsightsHeader);
